import React, { Component, Fragment } from "react";
import api from "../../../../services/api";
import MinCard from "../MinCard";

export default class Totais extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            modalidade: "Todas",
            metas: [],
            selectCampo: 0,
            nomeCampo: "numTurmas",
            tipos: [],
            totais: [],
            dr: 0
        }

    }

    async componentDidMount() {
        await this.loadMetas();
        this.calculaTipoPorMes();
    }

    componentDidUpdate(previousProps, previousState) {
        if (previousProps.resultados !== this.props.resultados) {
            this.calculaTipoPorMes();
        }
    }

    loadMetas = async () => {
        let metas = await api.get("/metasformatadas");
        this.setState({ metas: metas.data.metas });
    }

    calculaTipoPorMes = () => {

        let tipo = ["Pago", "Gratuidade Regimental", "Gratuidade Não-Regimental"];
        let resultados;
        let dados = tipo.map((tipo, i) => {
            resultados = ((this.props.resultados && this.props.resultados[i]) || []).reduce((acc, atual) => acc + atual, 0);
            return resultados;
        });

        let dr = dados.reduce((acc, total) => acc + total, 0);

        tipo = ["Pago", "Regimental", "Não-Regimental"];

        this.setState({
            tipos: tipo,
            totais: dados,
            dr: dr
        });

    }

    render() {
        return (
            <Fragment>
                <div className="row">
                    {this.state.tipos.map((tipo, i) => {
                        return <MinCard tipo={tipo} valor={this.state.totais[i]} key={i} />
                    })}
                    <MinCard tipo={["Total"]} valor={this.state.dr} />
                </div>
            </Fragment>
        )
    }
}